export const UI_LABELS = {
    effectivedate: "Start Date",
    inactivedate: "End Date",
    entity_type: "Entity",
    title: "Title",
    description: "Description",
    orgs_id: "Organization",
    reason: 'Reason',
    prior_auth_exumption: 'Prior Authorization Handling',
    current_status: 'Status',
    record_number: 'Code',
    modify_date: 'Modification Date',
    version: 'Version',
    clinical_criteria: 'Clinical Criteria',
    record_type: 'Record Type',
    is_active: 'Is Active',
    report_file: 'Report File',
    force_change_password: 'Force Password Change', // NOSONAR
    email: "Email",
    firstname: 'First Name',
    lastname: 'Last Name',
    username: 'User Name',
    weburl: 'URL',
    is_latest_version: 'Is Latest Version',
    pa_status: 'PA Status',
    dual_managed: 'Dual Managed',
    instruction: 'Instruction'
}

export const filterProps = {
    sourcing: 'sourcing',
    programs_id: 'programs_id',
    orgs_id: 'orgs_id',
    record_unique_identifier: 'record_unique_identifier',
    SK: 'SK',
    PK: 'PK',
    create_date: 'create_date',
    ignore_gap: 'ignore_gap',
    record_associated_SK: 'record_associated_SK',
    record_associated_to_PK: 'record_associated_to_PK',
    recordPK: 'recordPK',
    lob_id: 'lob_id',
    shortname: 'shortname',
    cognito_id: 'cognito_id',
    roles: 'roles',

}

export const categoryList = [
    'association', 
    'businesslines', 
    'clients', 
    'config',
    'groups', 
    'import_job', 
    'instructions', 
    'policies', 
    'policies_version', 
    'customize_policy', 
    'customize_sourcing', 
    'programs', 
    'report_custom_reports', 
    'report_standard_reports', 
    'transactions', 
    'user_logs', 
    'users'
];

export const categoryMap = {
    users: 'Users',
    programs: 'Programs',
    association: 'Association',
    policies_version: 'Policies Version',
    user_logs: 'User Logs',
    procedures: 'Procedures',
    customize_policy: 'Policy Types',
    customize_sourcing: 'Program Vendor',
    instructions: 'Instructions',
    businesslines: 'Business Lines',
    policies: 'Policies',
    orgs: 'Orgazinations',
    customize_client: 'Customize Client',
    groups: 'Groups',
    config: 'Configuration',
    transactions: 'Transactions',
    import_job: 'Import Job',
    report_custom_reports: 'Custom Reports',
    report_standard_reports: 'Standard Reports',
    clients: 'Clients',
    custom_reports: 'Custom Reports'
}

export const events = [
    'LOGIN',
    'LIST',
    'CREATE',
    'UPDATE',
    'DELETE',
    'DEACTIVATE',
    'REPORT_RUN',
    'IMPORT_RUN',
   // 'IMPORT'
];

export const eventsMap = {
    LOGIN: 'Login',
    LIST: 'List',
    CREATE: 'Create',
    UPDATE: 'Update',
    DELETE: 'Delete',
    DEACTIVATE: 'Disable',
    RUN_REPORT: 'Run Report',
    IMPORT_RUN: 'Import Run',
    IMPORT: 'Import'
};